import { useEffect, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { getLanguageFromURL } from "@/helpers";

interface LanguageAwareRouteProps {
  children: ReactNode;
}

/**
 * Wrapper component that detects language from URL parameters
 * and applies it to the i18n system before rendering children.
 * Used for public routes that can receive language parameters from external sources.
 */
function LanguageAwareRoute({ children }: LanguageAwareRouteProps) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const urlLanguage = getLanguageFromURL();
    
    if (urlLanguage && urlLanguage !== i18n.language) {
      // Change language if URL parameter is different from current language
      i18n.changeLanguage(urlLanguage);
    }
  }, [i18n]);

  return <>{children}</>;
}

export { LanguageAwareRoute };
